// ===========================================
// Note Item Component
// ===========================================

import { Box, Paper, Typography } from '@mui/material';
import { format } from 'date-fns';
import { Note } from '../../../api/notes.api';
import NoteContent from '../../notes/NoteContent';
import NoteVisibilityChip from './NoteVisibilityChip';

interface Props {
  note: Note;
  showFullContent?: boolean;
}

/**
 * Single note item display
 */
export default function NoteItem({ note, showFullContent = false }: Props) {
  // Render the byline only when there is a name to show — a bare "By " is
  // worse than no byline at all.
  const authorName = note.author
    ? `${note.author.firstName} ${note.author.lastName}`.trim()
    : '';

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 1 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="subtitle2">
            {note.lesson?.name || 'General Note'}
          </Typography>
          <NoteVisibilityChip visibility={note.visibility} />
        </Box>
        <Typography variant="caption" color="text.secondary">
          {format(new Date(note.createdAt), 'd MMM yyyy')}
        </Typography>
      </Box>
      <NoteContent content={note.content} showFullContent={showFullContent} />
      {authorName && (
        <Typography variant="caption" color="primary.main" sx={{ mt: 1, display: 'block' }}>
          By {authorName}
        </Typography>
      )}
    </Paper>
  );
}
